/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

export default angular.module('tektelic.api.event', [])
    .factory('eventService', EventService)
    .name;

/*@ngInject*/
function EventService($http, $q) {

    var service = {
        getEntityEvents: getEntityEvents,
        getAllEvents: getAllEvents
    }

    return service;

    function getEntityEvents (entityType, entityId, eventType, startTs, endTs) {
        var deferred = $q.defer();
        var url = `/api/entity/${entityType}/${entityId}/events/${eventType}?startTs=${startTs}`;
        if (endTs) {
            url += `&endTs=${endTs}`;
        }
        $http.get(url, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getAllEvents (eventTypes, startTs, endTs) {
        var deferred = $q.defer();

        var url = `/api/events?startTs=${startTs}`;
        if (endTs) {
            url += `&endTs=${endTs}`;
        }
        if (eventTypes && eventTypes.length) {
            url += `&eventType=${eventTypes.join(',')}`;
        }
        $http.get(url, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }
}



// WEBPACK FOOTER //
// ./src/app/api/event.service.js